import React from 'react';
import bgImg from 'assets/img/generic/14.jpg';
import AuthSplitLayout from 'layouts/AuthSplitLayout';
import ForgetPasswordForm from '../ForgetPasswordForm';

const ForgetPassword = () => {
  return (
    <AuthSplitLayout bgProps={{ image: bgImg, position: '50% 20%' }}>
      <div className="text-center">
        <h4 className="mb-0"> ¿Olvidó su contraseña?</h4>
        <small>
          Ingrese su mail y le enviaremos un link para que la restablezca
        </small>
        <ForgetPasswordForm layout="split" />
      </div>
    </AuthSplitLayout>
  );
};

export default ForgetPassword;
